import { render, staticRenderFns } from "./NewTable.vue?vue&type=template&id=7cd918e5&scoped=true&"
import script from "./NewTable.vue?vue&type=script&lang=js&"
export * from "./NewTable.vue?vue&type=script&lang=js&"
import style0 from "./NewTable.vue?vue&type=style&index=0&id=7cd918e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd918e5",
  null
  
)

export default component.exports